import { Box, Grid, HStack, Icon, Text, VStack } from '@wegroup/design-system';
import { SendOfferToAnvaBySessionIdResponse } from 'wg-api-sdk';
import { InsurancePolicyDocument } from '@flows/src/components/flow-products/quotes/basket/actions/InsurancePolicyDocument';

interface Props {
  data: SendOfferToAnvaBySessionIdResponse;
}

export const AnvaInsurancePoliciesDocumentList = ({ data }: Props) => {
  return (
    <VStack spacing="4" align="stretch">
      {data.policy_packages?.map((pkg) => (
        <Box
          key={pkg.id}
          bg="gray.ultraLight"
          border="1px"
          borderColor="gray.50"
          p="4"
          borderRadius="md"
        >
          <HStack spacing="2" align="center">
            <Icon name="GeneralOthersBox" />
            <Text textStyle="normalBodyMedium">{pkg.name}</Text>
          </HStack>
          {pkg.package_nr && (
            <Text color="gray.500" textStyle="smallBody">
              {pkg.package_nr}
            </Text>
          )}
          <Grid templateColumns="repeat(2, 1fr)" mt="3" gap="2">
            {pkg.documents.map((doc) => (
              <InsurancePolicyDocument
                key={doc.id}
                title={doc.filename}
                href={doc.link}
              />
            ))}
          </Grid>
        </Box>
      ))}
      {data.insurance_policies?.map((policy) => (
        <Box
          key={policy.id}
          bg="gray.ultraLight"
          border="1px"
          borderColor="gray.50"
          p="4"
          borderRadius="md"
        >
          <Text textStyle="normalBodyMedium">{policy.name}</Text>
          {policy.policy_nr && (
            <Text color="gray.500" textStyle="smallBody">
              {policy.policy_nr}
            </Text>
          )}
          <Grid templateColumns="repeat(2, 1fr)" mt="3" gap="2">
            {policy.documents.map((doc) => (
              <InsurancePolicyDocument
                key={doc.id}
                title={doc.filename}
                href={doc.link}
              />
            ))}
          </Grid>
        </Box>
      ))}
    </VStack>
  );
};
